export default __webpack_public_path__ + "static/media/23-ColoursOfItaly.532eaf5c.jpeg";